<template>
  <div class="grid gap-4">
    <p>Är du säker på att du vill ta bort utkastet?</p>
    <div class="flex justify-end gap-3">
      <AppButton @click="emit('close')">Avbryt</AppButton>
      <AppButton color="red" @click="confirm">Ta bort</AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { deleteDraftApplication, type ApplicationType } from '@/services/application'
import { deleteCommitmentDraft } from '@/services/commitment'
import { isCommitmentApplication } from '@/utils/applicationDisplay'
import { AppButton, useNotifications } from '@staff/ui'
const { notify } = useNotifications()
const props = defineProps<{
  applicationId: string
  applicationType: ApplicationType
  onSuccess: () => void | Promise<void>
}>()
const emit = defineEmits<{ (e: 'close'): void }>()

const isCommitment = computed(() => isCommitmentApplication(props.applicationType))
const entity = computed(() => (isCommitment.value ? 'Lånelöftet' : 'Ansökan'))

const confirm = async () => {
  const deleteDraft = isCommitment.value ? deleteCommitmentDraft : deleteDraftApplication

  try {
    await deleteDraft(props.applicationId)
  } catch (error) {
    notify({
      type: 'error',
      title: `Kunde inte ta bort ${entity.value.toLowerCase()}`,
      description: error instanceof Error ? error.message : 'Ett okänt fel uppstod.',
    })
    return
  }

  notify({ type: 'success', title: `${entity.value} har tagits bort` })

  await props.onSuccess()
  emit('close')
}
</script>
